import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, mergeProps as _mergeProps, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "flex flex-row"
}
const _hoisted_2 = { class: "flex flex-col w-full" }
const _hoisted_3 = { class: "container flex gap-2 justify-between max-w-5xl mx-auto overflow-x-auto p-5 pb-3 xl:flex-row" }
const _hoisted_4 = { class: "flex gap-2 items-center" }
const _hoisted_5 = { class: "h1" }
const _hoisted_6 = { class: "container flex flex-col gap-2 justify-between max-w-5xl mx-auto overflow-x-auto px-5 py-3 xl:flex-row" }
const _hoisted_7 = { class: "flex gap-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("svg", {
  width: "6",
  height: "10",
  viewBox: "0 0 6 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("line", {
    x1: "5",
    y1: "0.707107",
    x2: "0.707106",
    y2: "5",
    stroke: "#222B45",
    "stroke-linecap": "round"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "0.707107",
    y1: "5",
    x2: "5",
    y2: "9.29289",
    stroke: "#222B45",
    "stroke-linecap": "round"
  })
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "Back", -1)
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "container flex flex-col gap-2 max-w-5xl mx-auto overflow-x-auto p-5" }
const _hoisted_12 = { class: "flex flex-col gap-4 w-full" }
const _hoisted_13 = { class: "box-details flex flex-col gap-4 p-5" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "bg-gray-100 h-[1px] mr-3 w-full" }),
  /*#__PURE__*/_createElementVNode("p", { class: "min-w-max text uppercase" }, "General"),
  /*#__PURE__*/_createElementVNode("div", { class: "bg-gray-100 h-[1px] ml-3 w-full" })
], -1)
const _hoisted_15 = { class: "flex flex-col gap-2 items-start justify-between sm:flex-row" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col w-full sm:w-4/12" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "Store Name")
], -1)
const _hoisted_17 = { class: "flex flex-col items-end w-full sm:justify-end sm:w-8/12" }
const _hoisted_18 = { class: "flex flex-col gap-2 items-start justify-between sm:flex-row" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col w-full sm:w-4/12" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "Store Category")
], -1)
const _hoisted_20 = { class: "flex flex-col items-end w-full sm:justify-end sm:w-72" }
const _hoisted_21 = { class: "flex flex-col gap-2 items-start justify-between sm:flex-row" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col sm:w-4/12" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "Sub Categories")
], -1)
const _hoisted_23 = { class: "flex flex-col gap-1 items-end sm:justify-end w-full sm:w-72" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "pr-3 text-mini" }, " You can select one or more sub categories ", -1)
const _hoisted_25 = { class: "box-details flex flex-col gap-4 p-5" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "bg-gray-100 h-[1px] mr-3 w-full" }),
  /*#__PURE__*/_createElementVNode("p", { class: "min-w-max text uppercase" }, "Contact"),
  /*#__PURE__*/_createElementVNode("div", { class: "bg-gray-100 h-[1px] ml-3 w-full" })
], -1)
const _hoisted_27 = { class: "flex flex-col gap-2 items-start justify-between sm:flex-row" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col w-full sm:w-4/12" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "Store Email")
], -1)
const _hoisted_29 = { class: "flex flex-col items-end w-full sm:justify-end sm:w-8/12" }
const _hoisted_30 = { class: "flex flex-col gap-2 items-start justify-between sm:flex-row" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col w-full sm:w-4/12" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "Store Phone")
], -1)
const _hoisted_32 = { class: "flex gap-2 items-end w-full sm:justify-end sm:w-8/12" }
const _hoisted_33 = { class: "box-details flex flex-col gap-4 p-5" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "bg-gray-100 h-[1px] mr-3 w-full" }),
  /*#__PURE__*/_createElementVNode("p", { class: "min-w-max text uppercase" }, "Gallery"),
  /*#__PURE__*/_createElementVNode("div", { class: "bg-gray-100 h-[1px] ml-3 w-full" })
], -1)
const _hoisted_35 = { class: "flex flex-col gap-2 items-start justify-between sm:flex-row sm:items-center sm:justify-items-center" }
const _hoisted_36 = { class: "flex flex-col gap-2" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "Logo", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("p", { class: "text-mini" }, " We suggest to upload 1:1 format for better results. Size not smaller than 200px and not bigger than 500px, max file size 200kb and file format JPG or PNG. ", -1)
const _hoisted_39 = { class: "flex flex-col gap-2 items-start justify-between sm:flex-row sm:items-center sm:justify-items-center" }
const _hoisted_40 = { class: "w-full" }
const _hoisted_41 = { class: "flex flex-col gap-2" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "Cover", -1)
const _hoisted_43 = { class: "flex flex-wrap gap-2" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("p", { class: "text-mini" }, " You can upload up to 5 pictures and order them with drag-n-drop. We suggest to upload in 16:9 format for better results. Size not smaller than 500px and not bigger than 1920x1080, max file size 300kb for each picture and file format JPG or PNG. ", -1)
const _hoisted_45 = { class: "box-details flex flex-col gap-4 p-5" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "bg-gray-100 h-[1px] mr-3 w-full" }),
  /*#__PURE__*/_createElementVNode("p", { class: "min-w-max text uppercase" }, "Location and Time"),
  /*#__PURE__*/_createElementVNode("div", { class: "bg-gray-100 h-[1px] ml-3 w-full" })
], -1)
const _hoisted_47 = { class: "flex flex-col gap-2 items-start justify-between sm:flex-row" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col w-full sm:w-4/12" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "Address")
], -1)
const _hoisted_49 = { class: "flex flex-col gap-2 items-end w-full sm:w-9/12" }
const _hoisted_50 = { class: "flex gap-2 w-full sm:w-96" }
const _hoisted_51 = { class: "flex gap-2 w-full sm:w-96" }
const _hoisted_52 = { class: "flex gap-2 w-full sm:justify-end sm:w-96" }
const _hoisted_53 = { class: "flex flex-col gap-2 items-start justify-between sm:flex-row" }
const _hoisted_54 = { class: "flex flex-col w-full sm:w-4/12" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "Coordinates", -1)
const _hoisted_56 = { class: "text-mini" }
const _hoisted_57 = /*#__PURE__*/_createTextVNode(" Latitude and Longnitude are required to show your store in the App. You can get the exact coordinates from ")
const _hoisted_58 = ["href"]
const _hoisted_59 = { class: "flex gap-2 justify-center w-full sm:justify-end sm:w-6/12" }
const _hoisted_60 = { class: "flex flex-col items-center sm:items-end" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("span", { class: "pr-3 text-mini" }, "Latitude", -1)
const _hoisted_62 = { class: "flex flex-col items-center sm:items-end" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("span", { class: "pr-3 text-mini" }, "Longitude", -1)
const _hoisted_64 = {
  id: "column",
  class: "flex flex-col gap-2 items-start justify-between sm:flex-row"
}
const _hoisted_65 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col w-full sm:w-4/12" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "Timezone")
], -1)
const _hoisted_66 = { class: "flex flex-col gap-1 items-end w-full sm:justify-end sm:w-8/12" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("span", { class: "pr-3 text-mini" }, "Browser timezone: UTC+1:00 (Europe/Berlin)", -1)
const _hoisted_68 = { class: "box-details flex flex-col gap-4 p-5" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "bg-gray-100 h-[1px] mr-3 w-full" }),
  /*#__PURE__*/_createElementVNode("p", { class: "min-w-max text uppercase" }, "INFORMATION"),
  /*#__PURE__*/_createElementVNode("div", { class: "bg-gray-100 h-[1px] ml-3 w-full" })
], -1)
const _hoisted_70 = { class: "flex flex-col gap-2 items-start justify-between sm:flex-row" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col w-full sm:w-4/12" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "VAT Number"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-mini" }, "VAT Number is needed for invoices.")
], -1)
const _hoisted_72 = { class: "flex flex-col items-end w-full sm:justify-end sm:w-8/12" }
const _hoisted_73 = { class: "flex flex-col gap-2 items-start justify-between sm:flex-row" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col w-full sm:w-4/12" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "imPrint"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-mini" }, " Legal store name, addres, Registration etc. ")
], -1)
const _hoisted_75 = { class: "flex flex-col items-end w-full sm:justify-end sm:w-8/12" }
const _hoisted_76 = { class: "flex flex-col gap-2 items-start justify-between sm:flex-row" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col w-full sm:w-4/12" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "Store Description"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-mini" }, " Describe most usefull information about the store, history etc. ")
], -1)
const _hoisted_78 = { class: "flex flex-col items-end w-full sm:justify-end sm:w-8/12" }
const _hoisted_79 = { class: "box-details flex flex-col gap-4 p-5" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "bg-gray-100 h-[1px] mr-3 w-full" }),
  /*#__PURE__*/_createElementVNode("p", { class: "min-w-max text uppercase" }, "Order and Delivery"),
  /*#__PURE__*/_createElementVNode("div", { class: "bg-gray-100 h-[1px] ml-3 w-full" })
], -1)
const _hoisted_81 = { class: "flex flex-col gap-2 items-start justify-between sm:flex-row" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col w-full sm:w-4/12" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "Delivery Types")
], -1)
const _hoisted_83 = { class: "flex gap-6" }
const _hoisted_84 = { class: "flex gap-2 items-center" }
const _hoisted_85 = { class: "form-check" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "Delivery", -1)
const _hoisted_87 = { class: "flex gap-2 items-center" }
const _hoisted_88 = { class: "form-check" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "Pickup", -1)
const _hoisted_90 = { class: "flex gap-2 items-center" }
const _hoisted_91 = { class: "form-check" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "In Store", -1)
const _hoisted_93 = { class: "flex flex-col gap-2 items-start justify-between sm:flex-row" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col w-full sm:w-4/12" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "Min Order"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-mini" }, " Minimal order will affect only Delivery type. Pickup and In-Store have no minimal limit. ")
], -1)
const _hoisted_95 = { class: "flex flex-col gap-1 items-end sm:justify-end sm:w-8/12" }
const _hoisted_96 = { class: "flex flex-col gap-2 items-start justify-between sm:flex-row" }
const _hoisted_97 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col w-full sm:w-4/12" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "Delivery Radius"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-mini" }, " Delivery ragius will affect only Delivery type. Pickup and In-Store have no radius limit. ")
], -1)
const _hoisted_98 = { class: "flex flex-col gap-1 items-end w-full sm:justify-end sm:w-8/12" }
const _hoisted_99 = /*#__PURE__*/_createElementVNode("span", { class: "pr-3 text-mini" }, "If left blank, will be marked as 1000m", -1)
const _hoisted_100 = { class: "flex flex-col gap-2 items-start justify-between sm:flex-row" }
const _hoisted_101 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col w-full sm:w-4/12" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "Delivery Time"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-mini" }, " Delivery time will show on type Delivery. Pickup and In-Store have no effect. ")
], -1)
const _hoisted_102 = { class: "flex flex-col gap-1 items-end w-full sm:justify-end sm:w-8/12" }
const _hoisted_103 = /*#__PURE__*/_createElementVNode("span", { class: "pr-3 text-mini" }, "in minutes", -1)
const _hoisted_104 = { class: "flex flex-col gap-2 items-start justify-between sm:flex-row" }
const _hoisted_105 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col w-full sm:w-4/12" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "Delivery Cost"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-mini" }, " Delivery Cost will affect only Delivery type. Pickup and In-Store are always free. ")
], -1)
const _hoisted_106 = { class: "flex flex-col gap-1 items-end sm:justify-end sm:w-8/12 w-full" }
const _hoisted_107 = { class: "flex flex-row gap-2 items-start justify-between" }
const _hoisted_108 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col w-9/12 sm:w-4/12" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "Nearby Delivery"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-mini" }, " Activating Nearby Delivery to allow customers in a distance nearby to offer low cost or free delivery. ")
], -1)
const _hoisted_109 = { class: "flex gap-6 justify-end w-3/12 sm:w-8/12" }
const _hoisted_110 = { class: "flex items-center" }
const _hoisted_111 = ["checked"]
const _hoisted_112 = /*#__PURE__*/_createElementVNode("label", {
  for: "nearbyDelivery",
  id: "toggle",
  class: "bg-[#D1E8B4] cursor-pointer h-5 relative rounded-full w-9"
}, null, -1)
const _hoisted_113 = {
  key: 0,
  class: "flex flex-col gap-4"
}
const _hoisted_114 = { class: "flex flex-col gap-2 items-start justify-between sm:flex-row" }
const _hoisted_115 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col w-full sm:w-4/12" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "Nearby Min Order"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-mini" }, " Minimal order will affect only Delivery type. Pickup and In-Store have no minimal limit. ")
], -1)
const _hoisted_116 = { class: "flex flex-col gap-1 items-end sm:justify-end sm:w-8/12" }
const _hoisted_117 = { class: "flex flex-col gap-2 items-start justify-between sm:flex-row" }
const _hoisted_118 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col w-full sm:w-4/12" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "Nearby Delivery Radius"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-mini" }, " Delivery radius will affect only Delivery type. Pickup and In-Store have no radius limit. ")
], -1)
const _hoisted_119 = { class: "flex flex-col gap-1 items-end w-full sm:justify-end sm:w-8/12" }
const _hoisted_120 = /*#__PURE__*/_createElementVNode("span", { class: "pr-3 text-mini" }, "If left blank, will be marked as 1000m", -1)
const _hoisted_121 = { class: "flex flex-col gap-2 items-start justify-between sm:flex-row" }
const _hoisted_122 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col w-full sm:w-4/12" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "Nearby Delivery Time"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-mini" }, " Delivery time will show on type Delivery. Pickup and In-Store have no effect. ")
], -1)
const _hoisted_123 = { class: "flex flex-col gap-1 items-end w-full sm:justify-end sm:w-8/12" }
const _hoisted_124 = /*#__PURE__*/_createElementVNode("span", { class: "pr-3 text-mini" }, "in minutes", -1)
const _hoisted_125 = { class: "flex flex-col gap-2 items-start justify-between sm:flex-row" }
const _hoisted_126 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col w-full sm:w-4/12" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "Nearby Delivery Cost"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-mini" }, " Delivery Cost will affect only Delivery type. Pickup and In-Store are always free. ")
], -1)
const _hoisted_127 = { class: "flex flex-col gap-1 items-end sm:justify-end sm:w-8/12 w-full" }
const _hoisted_128 = { class: "flex flex-row gap-2 items-start justify-between" }
const _hoisted_129 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col w-9/12 sm:w-4/12" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "Table Numbers"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-mini" }, " Activating Tables means you can crete QR Code for each table. Users can scan and order in store. ")
], -1)
const _hoisted_130 = { class: "flex gap-6 justify-end w-3/12 sm:w-8/12" }
const _hoisted_131 = { class: "flex items-center" }
const _hoisted_132 = ["checked", "value"]
const _hoisted_133 = /*#__PURE__*/_createElementVNode("label", {
  for: "isActive",
  id: "toggle",
  class: "bg-[#D1E8B4] cursor-pointer h-5 relative rounded-full w-9"
}, null, -1)
const _hoisted_134 = { class: "box-details flex flex-col gap-4 p-5" }
const _hoisted_135 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "bg-gray-100 h-[1px] mr-3 w-full" }),
  /*#__PURE__*/_createElementVNode("p", { class: "min-w-max text uppercase" }, "Working Hours"),
  /*#__PURE__*/_createElementVNode("div", { class: "bg-gray-100 h-[1px] ml-3 w-full" })
], -1)
const _hoisted_136 = { class: "flex gap-2 items-center justify-between" }
const _hoisted_137 = { class: "flex gap-2 items-center" }
const _hoisted_138 = { class: "form-check" }
const _hoisted_139 = /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "Monday", -1)
const _hoisted_140 = { class: "flex gap-2 items-center" }
const _hoisted_141 = /*#__PURE__*/_createElementVNode("span", { class: "text" }, "to", -1)
const _hoisted_142 = { class: "flex gap-2 items-center justify-between" }
const _hoisted_143 = { class: "flex gap-2 items-center" }
const _hoisted_144 = { class: "form-check" }
const _hoisted_145 = /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "Tuesday", -1)
const _hoisted_146 = { class: "flex gap-2 items-center" }
const _hoisted_147 = /*#__PURE__*/_createElementVNode("span", { class: "text" }, "to", -1)
const _hoisted_148 = { class: "flex gap-2 items-center justify-between" }
const _hoisted_149 = { class: "flex gap-2 items-center" }
const _hoisted_150 = { class: "form-check" }
const _hoisted_151 = /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "Wednesday", -1)
const _hoisted_152 = { class: "flex gap-2 items-center" }
const _hoisted_153 = /*#__PURE__*/_createElementVNode("span", { class: "text" }, "to", -1)
const _hoisted_154 = { class: "flex gap-2 items-center justify-between" }
const _hoisted_155 = { class: "flex gap-2 items-center" }
const _hoisted_156 = { class: "form-check" }
const _hoisted_157 = /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "Thursday", -1)
const _hoisted_158 = { class: "flex gap-2 items-center" }
const _hoisted_159 = /*#__PURE__*/_createElementVNode("span", { class: "text" }, "to", -1)
const _hoisted_160 = { class: "flex gap-2 items-center justify-between" }
const _hoisted_161 = { class: "flex gap-2 items-center" }
const _hoisted_162 = { class: "form-check" }
const _hoisted_163 = /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "Friday", -1)
const _hoisted_164 = { class: "flex gap-2 items-center" }
const _hoisted_165 = /*#__PURE__*/_createElementVNode("span", { class: "text" }, "to", -1)
const _hoisted_166 = { class: "flex gap-2 items-center justify-between" }
const _hoisted_167 = { class: "flex gap-2 items-center" }
const _hoisted_168 = { class: "form-check" }
const _hoisted_169 = /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "Saturday", -1)
const _hoisted_170 = { class: "flex gap-2 items-center" }
const _hoisted_171 = /*#__PURE__*/_createElementVNode("span", { class: "text" }, "to", -1)
const _hoisted_172 = { class: "flex gap-2 items-center justify-between" }
const _hoisted_173 = { class: "flex gap-2 items-center" }
const _hoisted_174 = { class: "form-check" }
const _hoisted_175 = /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "Sunday", -1)
const _hoisted_176 = { class: "flex gap-2 items-center" }
const _hoisted_177 = /*#__PURE__*/_createElementVNode("span", { class: "text" }, "to", -1)
const _hoisted_178 = { class: "flex flex-row gap-2 items-start justify-between" }
const _hoisted_179 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col w-9/12 sm:w-4/12" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "Open/close store automatically"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-mini" }, " When setting to automatically, the store will open and close based on the given working time, otherwise it need to be changed manually. ")
], -1)
const _hoisted_180 = { class: "flex gap-6 justify-end w-3/12 sm:w-8/12" }
const _hoisted_181 = { class: "flex items-center" }
const _hoisted_182 = ["id", "value", "checked"]
const _hoisted_183 = ["for"]
const _hoisted_184 = { class: "flex flex-col gap-4 p-5" }
const _hoisted_185 = { class: "flex justify-end" }
const _hoisted_186 = ["onClick"]

import { COUNTRIES, Helpers } from "@/helper";
import { onMounted, reactive, ref } from "vue";
import { getTimezoneOffset, IdValue } from "@/helper";
import { useI18n } from "vue-i18n";
import {
  AddressEntity,
  CategoryEntity,
  CategoryFilterEntity,
  categoryservice,
  FilterEntity,
  MediaEntity,
  mediaservice,
  StoreCommissionEntity,
  StoreEntity,
  storeservice,
  StoreUserEntity,
} from "@/utils";
import { CategoryType, MediaType } from "@/globals/enums";
import { StoreCategoryEntity } from "@/utils/store/store-category.entity";
import { notify } from "@kyvg/vue3-notification";
import { useRouter } from "vue-router";
import { baseAPI } from "@/plugins";
import AutoComplete from "@/components/AutoComplete.vue";
import FileInputView from "@/components/base/file-input/FileInputView.vue";
import { useRoute } from "vue-router";
import Loader from "@/components/shared/loading/Loader.vue";
import { getSignedUrl } from "@/services/shared/image.service";
import { toFormData } from "@/services/shared/formdata.service";


export default /*#__PURE__*/_defineComponent({
  __name: 'AddStoreView',
  emits: ["close"],
  setup(__props, { emit: emits }) {



const storeId = useRoute().params.id || null;
const loading = ref(false);

const subCategories = ref<any>([]);
const enableNearbyDelivery = ref(false);
const storeSubCategories = ref<any>(null);

const Store = ref<any>({
  id: storeId,
  uniqueId: null,
  categoryId: "",
  name: null,
  logoImage: "",
  coverImage: "",
  email: null,
  phone: null,
  phoneCode: "+383",
  vatNumber: "",
  imPrint: "",
  nearbyDelivery: {
    status: enableNearbyDelivery.value ? "active" : "inactive",
    minOrder: {
      id: "0",
      value: "No Minimum",
    },
    deliveryTime: 0,
    deliveryCost: {
      id: "0",
      value: "Free Delivery",
    },
    deliveryRadius: 0,
  },
  description: "",
  status: null,
  commission: new StoreCommissionEntity(),
  isActive: false,
  storeUsers: [],
  address: {
    ...new AddressEntity(),
    zip: 10000,
    city: "",
    country: COUNTRIES.find(({ extra }) => extra?.isDefault),
  },
  minOrder: {
    id: "0",
    value: "No Minimum",
  },
  storeCategoryId: [],
  deliveryRadius: null,
  deliveryTime: null,
  deliveryCost: {
    id: "0",
    value: "Free Delivery",
  },
  deliveryType: ["delivery", "pickup", "in-store"],
  items: [],
  itemCategoriesSequence: null,
  tableCategoriesSequence: null,
  blockedStores: [],
  autoOpenClose: true,
  utc: {
    id: "+01:00",
    value: "UTC+01:00",
  },
  activateTables: false,
  totalRatings: 0,
  totalReviews: 0,
  workingHours: {
    monday: {
      to: "23:00",
      from: "07:00",
      enable: true,
    },
    tuesday: {
      to: "23:00",
      from: "07:00",
      enable: true,
    },
    wednesday: {
      to: "23:00",
      from: "07:00",
      enable: true,
    },
    thursday: {
      to: "23:00",
      from: "07:00",
      enable: true,
    },
    friday: {
      to: "23:00",
      from: "07:00",
      enable: true,
    },
    saturday: {
      to: "23:00",
      from: "07:00",
      enable: true,
    },
    sunday: {
      to: "23:00",
      from: "07:00",
      enable: true,
    },
  },
  category: "" as any,
});

const CITIES = ref<any>([
  { id: "prishtina", value: "Prishtinë" },
  { id: "prizren", value: "Prizren" },
  { id: "ferizaj", value: "Ferizaj" },
  { id: "gjakove", value: "Gjakovë" },
  { id: "gjilan", value: "Gjilan" },
  { id: "mitrovice", value: "Mitrovicë" },
  { id: "peje", value: "Pejë" },
  { id: "podujeve", value: "Podujevë" },
  { id: "prizren", value: "Prizren" },
  { id: "skenderaj", value: "Skenderaj" },
  { id: "suhareke", value: "Suharekë" },
  { id: "vushtrri", value: "Vushtrri" },
]);

const countriesList = ref<any>([
  {
    id: "albania",
    value: "Albania",
    extra: {
      isDefault: true,
    },
  },
  {
    id: "kosovo",
    value: "Kosovë",
    extra: {
      isDefault: false,
    },
  },
  {
    id: "macedonia",
    value: "Macedonia",
    extra: {
      isDefault: false,
    },
  },
  {
    id: "montenegro",
    value: "Montenegro",
    extra: {
      isDefault: false,
    },
  },
  {
    id: "serbia",
    value: "Serbia",
    extra: {
      isDefault: false,
    },
  },
  {
    id: "bosnia",
    value: "Bosnia",
    extra: {
      isDefault: false,
    },
  },
  {
    id: "other",
    value: "Other",
    extra: {
      isDefault: false,
    },
  },
]);

const { t } = useI18n();
const MinOrderValues = ref<Array<IdValue>>([]);
const DeliveryCostValues = ref<Array<IdValue>>([]);
const Categories = ref<Array<CategoryEntity>>([]);
const StoreCategories = ref<Array<StoreCategoryEntity>>([]);
const AddressesCity = ref<any[]>([]);
const AddressesZip = ref<any[]>([]);
const Offsets = [
  "-12:00",
  "-11:00",
  "-10:00",
  "-09:30",
  "-09:00",
  "-08:00",
  "-07:00",
  "-06:00",
  "-05:00",
  "-04:00",
  "-03:30",
  "-03:00",
  "-02:00",
  "-01:00",
  "-00:00",
  "+01:00",
  "+02:00",
  "+03:00",
  "+03:30",
  "+04:00",
  "+04:30",
  "+05:00",
  "+05:30",
  "+05:45",
  "+06:00",
  "+06:30",
  "+07:00",
  "+08:00",
  "+08:45",
  "+09:00",
  "+09:30",
  "+10:00",
  "+10:30",
  "+11:00",
  "+12:00",
  "+12:45",
  "+13:00",
  "+14:00",
].map((o) => ({ id: o, value: `UTC${o}` }));

const router = useRouter();

const nearbyDeliverySubmitted = (val: any) => {
  console.log("nearby delivery submitted", val);
  Store.value.nearbyDelivery = val;
};

const OffsetSubmitted = (val: any) => {
  console.log(Store.value.utc);
};
const StoreCategoriesSubmitted = (val: any) => {
  // Store.value.storeCategoryId = [];
  // console.log(" Store categories submitted", val);
  // Store.value.storeCategoryId = val?.map((v: any) => v?.id || v);
  // Store.value.storeCategoryId.push(val?.id);
};
const MinOrderSubmitted = (val: any) => {
  console.log(Store.value.MinOrder);
};
const DeliveryCostSubmitted = (val: any) => {
  console.log(Store.value.DeliveryCost, val, "store cost");
  Store.value.DeliveryCost = val.id;
};
const CategorySubmitted = async (val: any) => {
  console.log("Category submitted", val);
  subCategories.value = val?.storeCategory;
  Store.value.storeCategoryId = [];
  storeSubCategories.value = [];
  console.log("subcategories", subCategories.value);
};
const LogoSubmitted = async (val: any) => {
  console.log("logo submitted", val);
  Store.value.logoImage = val;
  // Store.value.logoImage = await mediaservice.convertToBlob(val);
  // mediaservice.upload()
};

const CoverImageSubmitted = async (val: any) => {
  console.log("cover submitted", val);
  Store.value.coverImage = val;
  // Store.value.coverImage = await mediaservice.convertToBlob(val);
};
const AddressCountrySubmitted = () => {
  console.log(Store.value.address.country);
};
const save = async () => {
  try {
    console.log("new Store", Store.value);
    const store: StoreEntity = JSON.parse(JSON.stringify(Store.value));
    delete store.member;

    const phone =
      store.phoneCode && store.phone ? store.phoneCode + " " + store.phone : "";
    store.phone = phone;
    store.deliveryRadius = store.deliveryRadius || 0;
    store.minOrder = parseFloat(Store.value.minOrder.id);
    store.deliveryCost = parseFloat(Store.value.deliveryCost.id);
    store.utc = Store.value.utc.id;
    store.categoryId = Store.value.category.id;
    store.imPrint = Store.value.imPrint;
    store.vatNumber = Store.value.vatNumber;
    store.address.city = Store.value.address.city.id;
    store.address.country = Store.value.address.country.id;
    store.storeCategoryId = storeSubCategories.value.map((cat: any) => cat.id);
    store.logoImage = Store.value.logoImage;
    store.coverImage = Store.value.coverImage;
    store.address.name = "Main";

    const newStore = ref({
      address: store.address,
      deliveryTime: store.deliveryTime,
      deliveryType: store.deliveryType,
      deliveryRadius: store.deliveryRadius,
      deliveryCost: store.deliveryCost,
      minOrder: store.minOrder,
      nearbyDelivery: store.nearbyDelivery,
      utc: store.utc,
      storeCategoryId: store.storeCategoryId,
      workingHours: store.workingHours,
    }) as any;
    console.log("Store object", store);

    console.log("New store object", newStore.value);

    const formData = new FormData();

    store.id ? formData.append("id", store.id as any) : null;
    formData.append("name", store.name as any);
    formData.append("categoryId", store.categoryId as any);
    formData.append("email", store.email as any);
    formData.append("phone", store.phone);
    formData.append("description", store.description as any);
    formData.append("vatNumber", store.vatNumber as any);
    formData.append("imPrint", store.imPrint as any);

    for (const i of Object.keys(store.deliveryType as any[])) {
      formData.append("deliveryType", store.deliveryType[i]);
    }
    formData.append("autoOpenClose", store.autoOpenClose as any);
    formData.append("activateTables", store.activateTables as any);
    formData.append("logoImage", store.logoImage as any);
    formData.append("coverImage", store.coverImage as any);

    // formData.append()

    // formData.append("minOrder", store.minOrder as any);
    // formData.append("deliveryRadius", store.deliveryRadius as any);
    // formData.append("deliveryCost", store.deliveryCost as any);
    // formData.append("deliveryTime", store.deliveryTime as any);
    // formData.append("utc", store.utc as any);
    // formData.append("address", JSON.parse(store.address));
    // formData.append("nearbyDelivery", store.nearbyDelivery);
    // formData.append("workingHours", store.workingHours);
    // console.log("formData", );
    for (var key in newStore.value) {
      formData.append(key, newStore.value[key]);
    }

    formData.forEach((value, key) => {
      console.log(key, value);
    });

    const data = { formData, store: newStore.value };
    if (store.id) {
      newStore.value = { ...store, ...newStore.value };
      newStore.value.removeStoreCategoryId = storeSubCategories.value.map(
        (cat: any) => cat.id
      );
      console.log("Save update");
      delete newStore.value.id;
      delete newStore.value._id;
      delete newStore.value.category;
      delete newStore.value.commission;
      delete newStore.value.id;
      delete newStore.value.member;
      delete newStore.value.createdAt;
      console.log("Save store", newStore.value);
      const form_data = toFormData(newStore.value);
      form_data.delete("storeCategoryId");
      newStore.value.storeCategoryId.forEach((subCategory: string) => {
        form_data.append("storeCategoryId[]", subCategory);
      });
      const res = await storeservice.updateStore(form_data, store.id);
      console.log("Add Response", res);
    } else {
      newStore.value = { ...store, ...newStore.value };
      const form_data = toFormData(newStore.value);
      newStore.value.storeCategoryId.forEach((subCategory: string) => {
        form_data.append("storeCategoryId[]", subCategory);
      });
      // const res = await storeservice.add(form_data);
      const res = await storeservice.add(form_data);
      console.log("Update Response", res);
    }
    const id = Date.now();
    notify({
      id,
      type: "success",
      duration: 5000,
      text: `${
        !Store.value.id
          ? `Store ${Store.value.name} added!`
          : "Store info updated!"
      }`,
    });
    router.push("/stores");
    emits("close");
  } catch (e: any) {
    const id = Date.now();
    console.log("Error", e);
    if (e?.response?.data?.message) {
      notify({
        id,
        type: "error",
        duration: 6000,
        text: e.response.data.message,
      });
    } else {
      e?.response?.data?.data.forEach((error: any) => {
        notify({
          id,
          type: "error",
          duration: 15000,
          text: error.msg,
        });
      });
    }
  }
};
const loadData = async () => {
  generateValues();
  if (!Categories.value.length) {
    await categoryservice
      .getAll(new FilterEntity({ Limit: 100000 }))
      .then(({ data }: any) => {
        console.log("Generate values", data);
        Categories.value = data.data as any;
      });
  }
  loadStoreCategories(false);
};
const loadStoreCategories = async (reset = true) => {
  if (reset) {
    StoreCategories.value = [];
    Store.value.storeCategories = [];
  }
};
const getStore = async () => {
  AddressesCity.value.push(Store.value.address.city);
  AddressesZip.value.push(Store.value.address.zip);
  return Store.value;
};
const generateValues = () => {
  let i = 0;
  while (i <= 25) {
    const obj: (type?: "min" | "delivery") => IdValue = (type = "min") => ({
      id: `${i}`,
      value: !i
        ? t(`${type === "delivery" ? "free-delivery" : "No Minimum"}`)
        : Helpers.toCurrency(i),
    });
    MinOrderValues.value.push(obj());
    if (i <= 5) {
      DeliveryCostValues.value.push(obj("delivery"));
    }
    i += 0.5;
  }
};

const toggleNearByDelivery = () => {
  enableNearbyDelivery.value = !enableNearbyDelivery.value;
  if (Store.value.nearbyDelivery === null) {
    Store.value.nearbyDelivery = {
      status: enableNearbyDelivery.value ? "active" : "inactive",
      minOrder: {
        id: "0",
        value: "No Minimum",
      },
      deliveryTime: 0,
      deliveryCost: {
        id: "0",
        value: "Free Delivery",
      },
      deliveryRadius: 0,
    };
  }
};

onMounted(async () => {
  console.log("Mounted add store");
  loading.value = true;
  await loadData();
  // getStore();
  if (storeId) {
    const res = await storeservice.getAll();
    res?.data?.data.filter((store) => {
      if (store.id === storeId) {
        console.log("selected store ", store);
        Store.value = store;
      }
    });

    console.log("General categories", Categories.value);
    subCategories.value = Store.value.storeCategoryId;
    if (Store.value.address == null) {
      Store.value.address = {
        name: "",
        street: "",
        country: "",
        city: "",
        longitude: 0,
        latitude: 0,
        zipCode: 0,
        additionalInformation: "",
        number: "",
      };
    } else {
      COUNTRIES.find((country: any) => {
        if (Store.value.address.country === country.id) {
          Store.value.address.country = country;
        }
      });
      CITIES.value.find((city: any) => {
        if (Store.value.address.city === city.id) {
          Store.value.address.city = city;
        }
      });
    }

    Store.value.phoneCode = "+383";

    const subcategories = ref<any>([]);

    Store.value.storeCategoryId.forEach((id: string) => {
      console.log("store category id", id);
      console.log("Store subcategories", subCategories.value);

      subCategories.value = Categories.value.find(
        (category: CategoryEntity) => category.id === Store.value.category.id
      )?.storeCategory;
      console.log("My store's category", subCategories);
      subCategories.value.map((subCategory: any) => {
        console.log("Store sub category ", subCategory);
        if (subCategory.id === id) {
          subcategories.value.push(subCategory);
        }
      });
    });
    storeSubCategories.value = subcategories.value;

    Offsets.find((offset: any) => {
      if (Store.value.utc === offset.id) {
        Store.value.utc = offset;
      }
    });

    MinOrderValues.value.find((value: any) => {
      if (Store.value.minOrder === parseFloat(value.id)) {
        Store.value.minOrder = value;
      }
    });

    DeliveryCostValues.value.find((value: any) => {
      if (Store.value.deliveryCost === parseFloat(value.id)) {
        Store.value.deliveryCost = value;
      }
    });

    // check if store has logo image
    if (
      Store.value.logoImage != null ||
      Store.value.logoImage != undefined ||
      Store.value.logoImage != ""
    ) {
      Store.value.logoImage = await getSignedUrl(Store.value.logoImage);
    } else {
      Store.value.logoImage = null;
    }

    if (Store.value.coverImage.length > 0) {
      Store.value.coverImage.forEach(async (image: string) => {
        image = await getSignedUrl(Store.value.coverImage);
      });
    } else {
      Store.value.coverImage = null;
    }
    console.log("Store in add store ", Store.value);
  }
  console.log("Data loaded", Categories.value);
  console.log("Store categories loaded", StoreCategories.value);
  loading.value = false;
});

return (_ctx: any,_cache: any) => {
  return (loading.value)
    ? (_openBlock(), _createBlock(Loader, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(storeId) ? "Edit" : "Add") + " Store", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", {
                class: "button-back cursor-pointer",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (
              _unref(storeId)
                ? _ctx.$router.push(`/store/${_ctx.$route.params.id}`)
                : _ctx.$router.push('/stores')
            ))
              }, _hoisted_10)
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("form", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("div", _hoisted_17, [
                    _withDirectives(_createElementVNode("input", {
                      required: "",
                      type: "text",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((Store.value.name) = $event)),
                      class: "form-field w-full sm:w-72"
                    }, null, 512), [
                      [_vModelText, Store.value.name]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(AutoComplete, {
                      class: "w-full",
                      "disabled-input": true,
                      modelValue: Store.value.category,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((Store.value.category) = $event)),
                      items: Categories.value,
                      "track-by": "name",
                      "show-by": "name",
                      placeholder: "Store Category",
                      onSubmit: _cache[3] || (_cache[3] = (val) => CategorySubmitted(val))
                    }, null, 8, ["modelValue", "items"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(AutoComplete, {
                      class: "w-full",
                      modelValue: storeSubCategories.value,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((storeSubCategories).value = $event)),
                      items: subCategories.value,
                      "track-by": "name",
                      "show-by": "name",
                      "filter-by": "name",
                      placeholder: "Sub Categories",
                      "disabled-input": true,
                      onSubmit: _cache[5] || (_cache[5] = (val) => StoreCategoriesSubmitted(val)),
                      multiple: true
                    }, null, 8, ["modelValue", "items"]),
                    _hoisted_24
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _createElementVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _createElementVNode("div", _hoisted_29, [
                    _withDirectives(_createElementVNode("input", {
                      required: "",
                      type: "text",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((Store.value.email) = $event)),
                      class: "form-field w-full sm:w-72"
                    }, null, 512), [
                      [_vModelText, Store.value.email]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _hoisted_31,
                  _createElementVNode("div", _hoisted_32, [
                    _withDirectives(_createElementVNode("input", {
                      id: "phoneCode",
                      required: "",
                      type: "text",
                      class: "form-field w-16",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((Store.value.phoneCode) = $event)),
                      maxlength: 4
                    }, null, 512), [
                      [_vModelText, Store.value.phoneCode]
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      id: "phone",
                      required: "",
                      type: "text",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((Store.value.phone) = $event)),
                      class: "form-field w-full sm:w-36"
                    }, null, 512), [
                      [_vModelText, Store.value.phone]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_33, [
                _hoisted_34,
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _hoisted_37,
                    _createVNode(FileInputView, {
                      modelValue: Store.value.logoImage,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((Store.value.logoImage) = $event)),
                      value: Store.value.logoImage,
                      rules: "image",
                      "field-name": "Logo",
                      "media-type": _unref(MediaType).STORE,
                      onInput: LogoSubmitted
                    }, null, 8, ["modelValue", "value", "media-type"]),
                    _hoisted_38
                  ])
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, [
                      _hoisted_42,
                      _createElementVNode("div", _hoisted_43, [
                        _createVNode(FileInputView, {
                          modelValue: Store.value.coverImage,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((Store.value.coverImage) = $event)),
                          value: Store.value.coverImage,
                          rules: "image",
                          "field-name": "CoverImage",
                          "media-type": _unref(MediaType).STORE,
                          onInput: CoverImageSubmitted
                        }, null, 8, ["modelValue", "value", "media-type"])
                      ]),
                      _hoisted_44
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_45, [
                _hoisted_46,
                _createElementVNode("div", _hoisted_47, [
                  _hoisted_48,
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("div", _hoisted_50, [
                      _withDirectives(_createElementVNode("input", {
                        required: "",
                        type: "text",
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((Store.value.address.street) = $event)),
                        class: "form-field w-8/12",
                        placeholder: "Street"
                      }, null, 512), [
                        [_vModelText, Store.value.address.street]
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        required: "",
                        type: "text",
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((Store.value.address.number) = $event)),
                        class: "form-field w-4/12",
                        placeholder: "No"
                      }, null, 512), [
                        [_vModelText, Store.value.address.number]
                      ])
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((Store.value.address.description) = $event)),
                      class: "form-field w-full sm:w-96",
                      placeholder: "Additional Description"
                    }, null, 512), [
                      [_vModelText, Store.value.address.description]
                    ]),
                    _createElementVNode("div", _hoisted_51, [
                      _createVNode(AutoComplete, {
                        class: "w-full",
                        modelValue: Store.value.address.city,
                        "onUpdate:modelValue": [
                          _cache[14] || (_cache[14] = ($event: any) => ((Store.value.address.city) = $event)),
                          _cache[16] || (_cache[16] = 
                      (value) => (Store.value.address.city = value)
                    )
                        ],
                        "track-by": "value",
                        "show-by": "value",
                        "filter-by": "value",
                        onSubmit: _cache[15] || (_cache[15] = (value) => (Store.value.address.city = value)),
                        items: CITIES.value,
                        placeholder: "City"
                      }, null, 8, ["modelValue", "items"]),
                      _withDirectives(_createElementVNode("input", {
                        required: "",
                        type: "text",
                        class: "form-field w-full",
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((Store.value.address.zipCode) = $event)),
                        placeholder: "Zip"
                      }, null, 512), [
                        [_vModelText, Store.value.address.zipCode]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_52, [
                      _createVNode(AutoComplete, {
                        class: "w-full",
                        modelValue: Store.value.address.country,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((Store.value.address.country) = $event)),
                        "track-by": "value",
                        "show-by": "value",
                        "filter-by": "value",
                        onSubmit: AddressCountrySubmitted,
                        items: countriesList.value,
                        placeholder: "Country"
                      }, null, 8, ["modelValue", "items"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("div", _hoisted_54, [
                    _hoisted_55,
                    _createElementVNode("p", _hoisted_56, [
                      _hoisted_57,
                      _createElementVNode("a", {
                        class: "text-primary font-bold",
                        href: `gps-coordinates.net`,
                        target: "_blank"
                      }, "gps-coordinates.net", 8, _hoisted_58)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("div", _hoisted_60, [
                      _withDirectives(_createElementVNode("input", {
                        required: "",
                        type: "text",
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((Store.value.address.latitude) = $event)),
                        class: "form-field w-full md:w-40",
                        placeholder: "42.422211"
                      }, null, 512), [
                        [_vModelText, Store.value.address.latitude]
                      ]),
                      _hoisted_61
                    ]),
                    _createElementVNode("div", _hoisted_62, [
                      _withDirectives(_createElementVNode("input", {
                        required: "",
                        type: "text",
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((Store.value.address.longitude) = $event)),
                        class: "form-field w-full md:w-40",
                        placeholder: "21.122211"
                      }, null, 512), [
                        [_vModelText, Store.value.address.longitude]
                      ]),
                      _hoisted_63
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_64, [
                  _hoisted_65,
                  _createElementVNode("div", _hoisted_66, [
                    _createVNode(AutoComplete, {
                      modelValue: Store.value.utc,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((Store.value.utc) = $event)),
                      items: _unref(Offsets),
                      "track-by": "value",
                      "show-by": "value",
                      placeholder: "TimeZone",
                      "remove-dash": true,
                      onSubmit: _cache[22] || (_cache[22] = (val) => OffsetSubmitted(val))
                    }, null, 8, ["modelValue", "items"]),
                    _hoisted_67
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_68, [
                _hoisted_69,
                _createElementVNode("div", _hoisted_70, [
                  _hoisted_71,
                  _createElementVNode("div", _hoisted_72, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-field w-full sm:w-72",
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((Store.value.vatNumber) = $event))
                    }, null, 512), [
                      [_vModelText, Store.value.vatNumber]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_73, [
                  _hoisted_74,
                  _createElementVNode("div", _hoisted_75, [
                    _withDirectives(_createElementVNode("textarea", {
                      rows: "5",
                      class: "form-field w-full",
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((Store.value.imPrint) = $event))
                    }, null, 512), [
                      [_vModelText, Store.value.imPrint]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_76, [
                  _hoisted_77,
                  _createElementVNode("div", _hoisted_78, [
                    _withDirectives(_createElementVNode("textarea", {
                      rows: "5",
                      class: "form-field w-full",
                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((Store.value.description) = $event))
                    }, null, 512), [
                      [_vModelText, Store.value.description]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_79, [
                _hoisted_80,
                _createElementVNode("div", _hoisted_81, [
                  _hoisted_82,
                  _createElementVNode("div", _hoisted_83, [
                    _createElementVNode("div", _hoisted_84, [
                      _createElementVNode("div", _hoisted_85, [
                        _withDirectives(_createElementVNode("input", {
                          required: "",
                          class: "appearance-none h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-[#ed5151] checked:border-[#ed5151] focus:outline-none transition duration-200 float-left cursor-pointer",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((Store.value.deliveryType) = $event)),
                          value: "delivery",
                          id: "flexCheckChecked"
                        }, null, 512), [
                          [_vModelCheckbox, Store.value.deliveryType]
                        ])
                      ]),
                      _hoisted_86
                    ]),
                    _createElementVNode("div", _hoisted_87, [
                      _createElementVNode("div", _hoisted_88, [
                        _withDirectives(_createElementVNode("input", {
                          required: "",
                          class: "appearance-none h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-[#ed5151] checked:border-[#ed5151] focus:outline-none transition duration-200 float-left cursor-pointer",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((Store.value.deliveryType) = $event)),
                          value: "pickup",
                          id: "flexCheckChecked"
                        }, null, 512), [
                          [_vModelCheckbox, Store.value.deliveryType]
                        ])
                      ]),
                      _hoisted_89
                    ]),
                    _createElementVNode("div", _hoisted_90, [
                      _createElementVNode("div", _hoisted_91, [
                        _withDirectives(_createElementVNode("input", {
                          required: "",
                          class: "appearance-none h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-[#ed5151] checked:border-[#ed5151] focus:outline-none transition duration-200 float-left cursor-pointer",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((Store.value.deliveryType) = $event)),
                          value: "in-store",
                          id: "flexCheckChecked"
                        }, null, 512), [
                          [_vModelCheckbox, Store.value.deliveryType]
                        ])
                      ]),
                      _hoisted_92
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_93, [
                  _hoisted_94,
                  _createElementVNode("div", _hoisted_95, [
                    _createVNode(AutoComplete, {
                      modelValue: Store.value.minOrder,
                      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((Store.value.minOrder) = $event)),
                      items: MinOrderValues.value,
                      "track-by": "value",
                      "show-by": "value",
                      "filter-by": "value",
                      placeholder: "Value",
                      onSubmit: _cache[30] || (_cache[30] = (val) => MinOrderSubmitted(val))
                    }, null, 8, ["modelValue", "items"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_96, [
                  _hoisted_97,
                  _createElementVNode("div", _hoisted_98, [
                    _withDirectives(_createElementVNode("input", {
                      required: "",
                      type: "number",
                      class: "form-field w-full sm:w-72",
                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((Store.value.deliveryRadius) = $event))
                    }, null, 512), [
                      [_vModelText, Store.value.deliveryRadius]
                    ]),
                    _hoisted_99
                  ])
                ]),
                _createElementVNode("div", _hoisted_100, [
                  _hoisted_101,
                  _createElementVNode("div", _hoisted_102, [
                    _withDirectives(_createElementVNode("input", {
                      required: "",
                      type: "number",
                      class: "form-field w-full sm:w-72",
                      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((Store.value.deliveryTime) = $event))
                    }, null, 512), [
                      [_vModelText, Store.value.deliveryTime]
                    ]),
                    _hoisted_103
                  ])
                ]),
                _createElementVNode("div", _hoisted_104, [
                  _hoisted_105,
                  _createElementVNode("div", _hoisted_106, [
                    _createVNode(AutoComplete, {
                      modelValue: Store.value.deliveryCost,
                      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((Store.value.deliveryCost) = $event)),
                      items: DeliveryCostValues.value,
                      "track-by": "value",
                      "show-by": "value",
                      "filter-by": "value",
                      "to-capitalize": true,
                      placeholder: "Select one",
                      onSubmit: _cache[34] || (_cache[34] = (val) => DeliveryCostSubmitted(val))
                    }, null, 8, ["modelValue", "items"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_107, [
                  _hoisted_108,
                  _createElementVNode("div", _hoisted_109, [
                    _createElementVNode("div", _hoisted_110, [
                      _createElementVNode("input", _mergeProps({
                        type: "checkbox",
                        id: "nearbyDelivery",
                        class: "hidden"
                      }, _ctx.$attrs, {
                        checked: !enableNearbyDelivery.value,
                        onChange: toggleNearByDelivery
                      }), null, 16, _hoisted_111),
                      _hoisted_112
                    ])
                  ])
                ]),
                (enableNearbyDelivery.value)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_113, [
                      _createElementVNode("div", _hoisted_114, [
                        _hoisted_115,
                        _createElementVNode("div", _hoisted_116, [
                          _createVNode(AutoComplete, {
                            modelValue: Store.value.nearbyDelivery.minOrder,
                            "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((Store.value.nearbyDelivery.minOrder) = $event)),
                            items: MinOrderValues.value,
                            "track-by": "value",
                            "show-by": "value",
                            "filter-by": "value",
                            placeholder: "Value",
                            onSubmit: _cache[36] || (_cache[36] = (val) => (Store.value.nearbyDelivery.minOrder = parseFloat(val?.value?.split('€')[0].trim()))  || val?.value.id)
                          }, null, 8, ["modelValue", "items"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_117, [
                        _hoisted_118,
                        _createElementVNode("div", _hoisted_119, [
                          _withDirectives(_createElementVNode("input", {
                            required: "",
                            type: "number",
                            class: "form-field w-full sm:w-72",
                            "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((Store.value.nearbyDelivery.deliveryRadius) = $event))
                          }, null, 512), [
                            [_vModelText, Store.value.nearbyDelivery.deliveryRadius]
                          ]),
                          _hoisted_120
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_121, [
                        _hoisted_122,
                        _createElementVNode("div", _hoisted_123, [
                          _withDirectives(_createElementVNode("input", {
                            required: "",
                            type: "number",
                            class: "form-field w-full sm:w-72",
                            "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((Store.value.nearbyDelivery.deliveryTime) = $event))
                          }, null, 512), [
                            [_vModelText, Store.value.nearbyDelivery.deliveryTime]
                          ]),
                          _hoisted_124
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_125, [
                        _hoisted_126,
                        _createElementVNode("div", _hoisted_127, [
                          _createVNode(AutoComplete, {
                            modelValue: Store.value.nearbyDelivery.deliveryCost,
                            "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((Store.value.nearbyDelivery.deliveryCost) = $event)),
                            items: DeliveryCostValues.value,
                            "track-by": "value",
                            "show-by": "value",
                            "filter-by": "value",
                            "to-capitalize": true,
                            placeholder: "Select one",
                            onSubmit: _cache[40] || (_cache[40] = (val) => Store.value.nearbyDelivery.deliveryCost = parseFloat(val?.value?.split('€')[0].trim()) || val?.value.id)
                          }, null, 8, ["modelValue", "items"])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_128, [
                  _hoisted_129,
                  _createElementVNode("div", _hoisted_130, [
                    _createElementVNode("div", _hoisted_131, [
                      _createElementVNode("input", _mergeProps({
                        required: "",
                        type: "checkbox",
                        id: "isActive",
                        class: "hidden"
                      }, _ctx.$attrs, {
                        checked: !Store.value.isActive,
                        value: Store.value.isActive
                      }), null, 16, _hoisted_132),
                      _hoisted_133
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_134, [
                _hoisted_135,
                _createElementVNode("div", _hoisted_136, [
                  _createElementVNode("div", _hoisted_137, [
                    _createElementVNode("div", _hoisted_138, [
                      _withDirectives(_createElementVNode("input", {
                        class: "appearance-none h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-[#ed5151] checked:border-[#ed5151] focus:outline-none transition duration-200 float-left cursor-pointer",
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((Store.value.workingHours.monday.enable) = $event)),
                        id: "flexCheckChecked"
                      }, null, 512), [
                        [_vModelCheckbox, Store.value.workingHours.monday.enable]
                      ])
                    ]),
                    _hoisted_139
                  ]),
                  _createElementVNode("div", _hoisted_140, [
                    _withDirectives(_createElementVNode("input", {
                      required: "",
                      type: "time",
                      class: "form-field w-28",
                      "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((Store.value.workingHours.monday.from) = $event))
                    }, null, 512), [
                      [_vModelText, Store.value.workingHours.monday.from]
                    ]),
                    _hoisted_141,
                    _withDirectives(_createElementVNode("input", {
                      required: "",
                      type: "time",
                      class: "form-field w-28",
                      "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((Store.value.workingHours.monday.to) = $event))
                    }, null, 512), [
                      [_vModelText, Store.value.workingHours.monday.to]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_142, [
                  _createElementVNode("div", _hoisted_143, [
                    _createElementVNode("div", _hoisted_144, [
                      _withDirectives(_createElementVNode("input", {
                        class: "appearance-none h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-[#ed5151] checked:border-[#ed5151] focus:outline-none transition duration-200 float-left cursor-pointer",
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((Store.value.workingHours.tuesday.enable) = $event)),
                        id: "flexCheckChecked"
                      }, null, 512), [
                        [_vModelCheckbox, Store.value.workingHours.tuesday.enable]
                      ])
                    ]),
                    _hoisted_145
                  ]),
                  _createElementVNode("div", _hoisted_146, [
                    _withDirectives(_createElementVNode("input", {
                      required: "",
                      type: "time",
                      class: "form-field w-28",
                      "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((Store.value.workingHours.tuesday.from) = $event))
                    }, null, 512), [
                      [_vModelText, Store.value.workingHours.tuesday.from]
                    ]),
                    _hoisted_147,
                    _withDirectives(_createElementVNode("input", {
                      required: "",
                      type: "time",
                      class: "form-field w-28",
                      "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((Store.value.workingHours.tuesday.to) = $event))
                    }, null, 512), [
                      [_vModelText, Store.value.workingHours.tuesday.to]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_148, [
                  _createElementVNode("div", _hoisted_149, [
                    _createElementVNode("div", _hoisted_150, [
                      _withDirectives(_createElementVNode("input", {
                        class: "appearance-none h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-[#ed5151] checked:border-[#ed5151] focus:outline-none transition duration-200 float-left cursor-pointer",
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((Store.value.workingHours.wednesday.enable) = $event)),
                        id: "flexCheckChecked"
                      }, null, 512), [
                        [_vModelCheckbox, Store.value.workingHours.wednesday.enable]
                      ])
                    ]),
                    _hoisted_151
                  ]),
                  _createElementVNode("div", _hoisted_152, [
                    _withDirectives(_createElementVNode("input", {
                      required: "",
                      type: "time",
                      class: "form-field w-28",
                      "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((Store.value.workingHours.wednesday.from) = $event))
                    }, null, 512), [
                      [_vModelText, Store.value.workingHours.wednesday.from]
                    ]),
                    _hoisted_153,
                    _withDirectives(_createElementVNode("input", {
                      required: "",
                      type: "time",
                      class: "form-field w-28",
                      "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((Store.value.workingHours.wednesday.to) = $event))
                    }, null, 512), [
                      [_vModelText, Store.value.workingHours.wednesday.to]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_154, [
                  _createElementVNode("div", _hoisted_155, [
                    _createElementVNode("div", _hoisted_156, [
                      _withDirectives(_createElementVNode("input", {
                        class: "appearance-none h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-[#ed5151] checked:border-[#ed5151] focus:outline-none transition duration-200 float-left cursor-pointer",
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((Store.value.workingHours.thursday.enable) = $event)),
                        id: "flexCheckChecked"
                      }, null, 512), [
                        [_vModelCheckbox, Store.value.workingHours.thursday.enable]
                      ])
                    ]),
                    _hoisted_157
                  ]),
                  _createElementVNode("div", _hoisted_158, [
                    _withDirectives(_createElementVNode("input", {
                      required: "",
                      type: "time",
                      class: "form-field w-28",
                      "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((Store.value.workingHours.thursday.from) = $event))
                    }, null, 512), [
                      [_vModelText, Store.value.workingHours.thursday.from]
                    ]),
                    _hoisted_159,
                    _withDirectives(_createElementVNode("input", {
                      required: "",
                      type: "time",
                      class: "form-field w-28",
                      "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((Store.value.workingHours.thursday.to) = $event))
                    }, null, 512), [
                      [_vModelText, Store.value.workingHours.thursday.to]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_160, [
                  _createElementVNode("div", _hoisted_161, [
                    _createElementVNode("div", _hoisted_162, [
                      _withDirectives(_createElementVNode("input", {
                        class: "appearance-none h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-[#ed5151] checked:border-[#ed5151] focus:outline-none transition duration-200 float-left cursor-pointer",
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((Store.value.workingHours.friday.enable) = $event)),
                        id: "flexCheckChecked"
                      }, null, 512), [
                        [_vModelCheckbox, Store.value.workingHours.friday.enable]
                      ])
                    ]),
                    _hoisted_163
                  ]),
                  _createElementVNode("div", _hoisted_164, [
                    _withDirectives(_createElementVNode("input", {
                      required: "",
                      type: "time",
                      class: "form-field w-28",
                      "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((Store.value.workingHours.friday.from) = $event))
                    }, null, 512), [
                      [_vModelText, Store.value.workingHours.friday.from]
                    ]),
                    _hoisted_165,
                    _withDirectives(_createElementVNode("input", {
                      required: "",
                      type: "time",
                      class: "form-field w-28",
                      "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((Store.value.workingHours.friday.to) = $event))
                    }, null, 512), [
                      [_vModelText, Store.value.workingHours.friday.to]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_166, [
                  _createElementVNode("div", _hoisted_167, [
                    _createElementVNode("div", _hoisted_168, [
                      _withDirectives(_createElementVNode("input", {
                        class: "appearance-none h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-[#ed5151] checked:border-[#ed5151] focus:outline-none transition duration-200 float-left cursor-pointer",
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((Store.value.workingHours.saturday.enable) = $event)),
                        id: "flexCheckChecked"
                      }, null, 512), [
                        [_vModelCheckbox, Store.value.workingHours.saturday.enable]
                      ])
                    ]),
                    _hoisted_169
                  ]),
                  _createElementVNode("div", _hoisted_170, [
                    _withDirectives(_createElementVNode("input", {
                      required: "",
                      type: "time",
                      class: "form-field w-28",
                      "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((Store.value.workingHours.saturday.from) = $event))
                    }, null, 512), [
                      [_vModelText, Store.value.workingHours.saturday.from]
                    ]),
                    _hoisted_171,
                    _withDirectives(_createElementVNode("input", {
                      required: "",
                      type: "time",
                      class: "form-field w-28",
                      "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((Store.value.workingHours.saturday.to) = $event))
                    }, null, 512), [
                      [_vModelText, Store.value.workingHours.saturday.to]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_172, [
                  _createElementVNode("div", _hoisted_173, [
                    _createElementVNode("div", _hoisted_174, [
                      _withDirectives(_createElementVNode("input", {
                        class: "appearance-none h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-[#ed5151] checked:border-[#ed5151] focus:outline-none transition duration-200 float-left cursor-pointer",
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((Store.value.workingHours.sunday.enable) = $event)),
                        id: "flexCheckChecked"
                      }, null, 512), [
                        [_vModelCheckbox, Store.value.workingHours.sunday.enable]
                      ])
                    ]),
                    _hoisted_175
                  ]),
                  _createElementVNode("div", _hoisted_176, [
                    _withDirectives(_createElementVNode("input", {
                      required: "",
                      type: "time",
                      class: "form-field w-28",
                      "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((Store.value.workingHours.sunday.from) = $event))
                    }, null, 512), [
                      [_vModelText, Store.value.workingHours.sunday.from]
                    ]),
                    _hoisted_177,
                    _withDirectives(_createElementVNode("input", {
                      required: "",
                      type: "time",
                      class: "form-field w-28",
                      "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((Store.value.workingHours.sunday.to) = $event))
                    }, null, 512), [
                      [_vModelText, Store.value.workingHours.sunday.to]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_178, [
                  _hoisted_179,
                  _createElementVNode("div", _hoisted_180, [
                    _createElementVNode("div", _hoisted_181, [
                      _createElementVNode("input", {
                        type: "checkbox",
                        id: `auto-${Store.value.id}`,
                        class: "hidden",
                        value: Store.value.autoOpenClose,
                        checked: !Store.value.autoOpenClose,
                        onChange: _cache[62] || (_cache[62] = ($event: any) => (Store.value.autoOpenClose = !Store.value.autoOpenClose))
                      }, null, 40, _hoisted_182),
                      _createElementVNode("label", {
                        for: `auto-${Store.value.id}`,
                        id: "toggle",
                        class: "bg-[#D1E8B4] cursor-pointer h-5 relative rounded-full w-9"
                      }, null, 8, _hoisted_183)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_184, [
                _createElementVNode("div", _hoisted_185, [
                  _createElementVNode("button", {
                    class: "button",
                    type: "submit",
                    onClick: _withModifiers(save, ["prevent"])
                  }, [
                    _createElementVNode("span", null, _toDisplayString(Store.value.id ? "Update" : "Add Store"), 1)
                  ], 8, _hoisted_186)
                ])
              ])
            ])
          ])
        ])
      ]))
}
}

})